import { useRef, Fragment, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Formik, Field } from 'formik';
import styled, { withTheme } from 'styled-components';
import { useCookies } from 'react-cookie';
import * as yup from 'yup';

import {
    FovInput,
    FovFieldError,
    Tags,
    VerticalSpacer,
    FovButton,
    FovModal,
} from 'components';

import { createTeamAdmin } from 'store/actions/admin';

const ButtonContainer = styled('div')`
    display: inline-flex;
    width: 100%;
    max-width: 25rem;
`;

const InputContainer = styled('div')`
    max-width: 25rem;
`;

const AddTeamForm = withTheme(props => {
    const { isVisible, onClose } = props;

    const dispatch = useDispatch();
    const formikRef = useRef();

    const [ cookies ] = useCookies([ 'userAuth' ]);
    const token = cookies.archvision_token;

    const setRef = form => {
        if (!formikRef.current) {
            formikRef.current = form;
        }
    };

    const handleSubmit = useCallback(args => {
        const { values, setSubmitting } = args;
        const { displayName, domains } = values;
        const domainArr = domains.split(',');

        dispatch(createTeamAdmin(
            token,
            { name: displayName, allowedDomains: domainArr },
        ))
            .finally(() => {
                setSubmitting(false);
                onClose();
            });
    }, []);

    const defaults = {
        displayName: '',
        domains: '',
    };

    const schema = yup.object().shape({
        displayName: yup.string().required('A display name is required.'),
        domains: yup.string().required('At least one domain is required.')
            .test('is-valid',
                'All domains must start with @',
                value => value?.split?.(',').every(domain => domain.startsWith('@')),
            ),
    });


    return (
        <FovModal
            title='Create a team'
            visible={isVisible}
            onClose={onClose}
        >
        <Fragment>
            <Formik
                initialValues={defaults}
                validationSchema={schema}
                onSubmit={(values, handlers) => {
                    const { setSubmitting } = handlers;
                    handleSubmit({ values, setSubmitting });
                }}
                validateOnChange={true}
            >
            {form => (
                <Fragment>
                {setRef(form)}
                Display Name
                <Field type='text' name='displayName'>
                {data => (
                    <InputContainer>
                        <FovInput
                            value={data.field.value}
                            placeholder={''}
                            {...data.field}
                            onChange={e => {
                                const newVal = e.target.value;
                                form.setFieldValue(data.field.name, newVal);
                            }}
                        />
                    </InputContainer>
                )}
                </Field>
                <FovFieldError name='displayName' />

                Domains
                <VerticalSpacer size={10} />

                <Field type='input' name='domains'>
                {data => (
                    <Tags
                        values={data.field.value ? data.field.value : []}
                        newTagText='Add domain'
                        onChange={(e, domains) => {
                            form.setFieldValue(data.field.name, domains);
                        }}
                    />
                )}
                </Field>
                <FovFieldError name='domains' />
                <ButtonContainer>
                    <FovButton
                        type='submit'
                        disabled={form.isSubmitting}
                        onClick={form.handleSubmit}
                    >
                    Save Settings
                    </FovButton>
                </ButtonContainer>


                </Fragment>
            )}
            </Formik>
        </Fragment>
        </FovModal>
    );
});

export { AddTeamForm };
